import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionLaboratories: ITrialInstitutionLaboratoriesLoadActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD
        }
    },
    LoadTrialInstitutionLaboratoriesByTrialInstitutionId: ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdActionCreator = (trialInstitutionId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID,
            trialInstitutionId
        }
    },
    LoadTrialInstitutionLaboratoriesByTrialId: ITrialInstitutionLaboratoriesLoadByTrialIdActionCreator = (trialId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID,
            trialId
        }
    },
    LoadTrialInstitutionLaboratoryById: ITrialInstitutionLaboratoryLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID,
            id
        }
    },
    LoadTrialInstitutionLaboratoryByLaboratoryId: ITrialInstitutionLaboratoryLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadSuccess: ITrialInstitutionLaboratoryLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionLaboratoryLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionLaboratory: ITrialInstitutionLaboratorySaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionLaboratorySaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionLaboratorySaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionLaboratory: ITrialInstitutionLaboratoryCreateActionCreator = (laboratoryId, trialInstitutionId) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_CREATE,
            laboratoryId,
            trialInstitutionId
        }
    },
    CreateSuccess: ITrialInstitutionLaboratoryCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionLaboratoryCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialInstitutionLaboratory: ITrialInstitutionLaboratoryDeleteActionCreator = (id) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialInstitutionLaboratoryDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialInstitutionLaboratoryDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionLaboratory: ITrialInstitutionLaboratoryValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionLaboratoryValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionLaboratoryValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionLaboratoryClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionLaboratoryFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORY_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORY_SAVE = "ACTION_TRIALINSTITUTIONLABORATORY_SAVE",
    ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORY_CREATE = "ACTION_TRIALINSTITUTIONLABORATORY_CREATE",
    ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORY_DELETE = "ACTION_TRIALINSTITUTIONLABORATORY_DELETE",
    ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE = "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE",
    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORY_CLEAR = "ACTION_TRIALINSTITUTIONLABORATORY_CLEAR",

    ACTION_TRIALINSTITUTIONLABORATORY_FILTER = "ACTION_TRIALINSTITUTIONLABORATORY_FILTER";

export interface ITrialInstitutionLaboratoriesLoadAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD";
}

export interface ITrialInstitutionLaboratoriesLoadActionCreator {
    (): ITrialInstitutionLaboratoriesLoadAction;
}

export interface ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALINSTITUTIONID";
    trialInstitutionId
}

export interface ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdActionCreator {
    (trialInstitutionId): ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdAction;
}

export interface ITrialInstitutionLaboratoriesLoadByTrialIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_TRIALID";
    trialId
}

export interface ITrialInstitutionLaboratoriesLoadByTrialIdActionCreator {
    (trialId): ITrialInstitutionLaboratoriesLoadByTrialIdAction;
}

export interface ITrialInstitutionLaboratoryLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratory | Dtos.TrialInstitutionLaboratory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory | Dtos.TrialInstitutionLaboratory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryLoadSuccessAction;
}

export interface ITrialInstitutionLaboratoryLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryLoadFailureAction;
}

export interface ITrialInstitutionLaboratoryLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionLaboratoryLoadByIdActionCreator {
    (id: number): ITrialInstitutionLaboratoryLoadByIdAction;
}

export interface ITrialInstitutionLaboratoryLoadByLaboratoryIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ITrialInstitutionLaboratoryLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ITrialInstitutionLaboratoryLoadByLaboratoryIdAction;
}

export interface ITrialInstitutionLaboratorySaveAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_SAVE";
    formData: Dtos.TrialInstitutionLaboratory;

}

export interface ITrialInstitutionLaboratorySaveActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory
    ): ITrialInstitutionLaboratorySaveAction;
}

export interface ITrialInstitutionLaboratorySaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratorySaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratorySaveSuccessAction;
}

export interface ITrialInstitutionLaboratorySaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratorySaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratorySaveFailureAction;
}

export interface ITrialInstitutionLaboratoryCreateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_CREATE";
    laboratoryId: number | null;
    trialInstitutionId: number | null;
}

export interface ITrialInstitutionLaboratoryCreateActionCreator {
    (laboratoryId: number | null, trialInstitutionId: number | null): ITrialInstitutionLaboratoryCreateAction
}

export interface ITrialInstitutionLaboratoryCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratory;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialInstitutionLaboratoryCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionLaboratoryCreateSuccessAction;
}

export interface ITrialInstitutionLaboratoryCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryCreateFailureAction;
}

export interface ITrialInstitutionLaboratoryDeleteAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_DELETE";
    id: number;
}

export interface ITrialInstitutionLaboratoryDeleteActionCreator {
    (id: number): ITrialInstitutionLaboratoryDeleteAction
}

export interface ITrialInstitutionLaboratoryDeleteSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_DELETE_SUCCESS";
}

export interface ITrialInstitutionLaboratoryDeleteSuccessActionCreator {
    (): ITrialInstitutionLaboratoryDeleteSuccessAction;
}

export interface ITrialInstitutionLaboratoryDeleteFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryDeleteFailureAction;
}

export interface ITrialInstitutionLaboratoryValidateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE";
    formData: Dtos.TrialInstitutionLaboratory;

}

export interface ITrialInstitutionLaboratoryValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory
    ): ITrialInstitutionLaboratoryValidateAction;
}

export interface ITrialInstitutionLaboratoryValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratory;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratory,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryValidateSuccessAction;
}

export interface ITrialInstitutionLaboratoryValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryValidateFailureAction;
}

export interface ITrialInstitutionLaboratoryClearAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionLaboratoryClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionLaboratoryClearAction;
}

export interface ITrialInstitutionLaboratoryFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionLaboratoryFilterAction;
}

export interface ITrialInstitutionLaboratoryFilterAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORY_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionLaboratoryAction =
    ITrialInstitutionLaboratoriesLoadAction |
    ITrialInstitutionLaboratoriesLoadByTrialInstitutionIdAction |
    ITrialInstitutionLaboratoriesLoadByTrialIdAction |
    ITrialInstitutionLaboratoryLoadByIdAction |
    ITrialInstitutionLaboratoryLoadByLaboratoryIdAction |
    ITrialInstitutionLaboratoryLoadFailureAction |
    ITrialInstitutionLaboratoryLoadSuccessAction |
    ITrialInstitutionLaboratorySaveAction |
    ITrialInstitutionLaboratorySaveSuccessAction |
    ITrialInstitutionLaboratorySaveFailureAction |
    ITrialInstitutionLaboratoryCreateAction |
    ITrialInstitutionLaboratoryCreateSuccessAction |
    ITrialInstitutionLaboratoryCreateFailureAction |
    ITrialInstitutionLaboratoryDeleteAction |
    ITrialInstitutionLaboratoryDeleteSuccessAction |
    ITrialInstitutionLaboratoryDeleteFailureAction |
    ITrialInstitutionLaboratoryValidateAction |
    ITrialInstitutionLaboratoryValidateSuccessAction |
    ITrialInstitutionLaboratoryValidateFailureAction |
    ITrialInstitutionLaboratoryClearAction |
    ITrialInstitutionLaboratoryFilterAction;
